module.exports = "/images/setup.jpg?9864a2ad760ae3f552a3b1b994e65a8b";